import css from 'styled-jsx/css';

const styles = css.global`#leilao-de-veiculos-fique-atento {
  padding: 32px 0;
  position: relative;
  background: #FBFBFB;
}

#leilao-de-veiculos-fique-atento .fique-atento-contain,
#leilao-de-veiculos-fique-atento .fique-atento-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#leilao-de-veiculos-fique-atento .fique-atento-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
}

#leilao-de-veiculos-fique-atento .fique-atento-texto {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#leilao-de-veiculos-fique-atento .fique-atento-texto p {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#leilao-de-veiculos-fique-atento .fique-atento-texto p b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#leilao-de-veiculos-fique-atento .fique-atento-img {
  width: 192px;
  margin: auto;
}

#leilao-de-veiculos-fique-atento .fique-atento-btn {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: auto;
}

#leilao-de-veiculos-disclaimer {
  padding-top: 8px;
}

#leilao-de-veiculos-disclaimer .leilao-de-veiculos-disclaimer-texto {
  color: #999;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
}

@media (min-width: 992px) {
  #leilao-de-veiculos-fique-atento .ctn-home-24 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  #leilao-de-veiculos-fique-atento {
    padding: 48px 0;
  }
  
  #leilao-de-veiculos-fique-atento .fique-atento-contain {
    gap: 33px;
    max-width: 680px;
  }

  #leilao-de-veiculos-fique-atento .fique-atento-texto p {
    font-size: 20px;
    line-height: 140%;
  }
  
  #leilao-de-veiculos-fique-atento .fique-atento-texto p b {
    font-size: 32px;
  }

  #leilao-de-veiculos-fique-atento .fique-atento-img {
    width: 372px;
  }

  #leilao-de-veiculos-fique-atento .fique-atento-btn {
    margin: 0;
  }
}`;

export default styles;